import React from 'react';
import './OrderCardStatus.less';

export const OrderCardStatus = ({status, title}) => {
	return <div className="order-card-status">
		<span className="order-card-status__order-status">{status}</span>
		<span className="order-card-status__order-connector">·</span>
		<span className="order-card-status__order-title">{title}</span>
	</div>
}
